module.exports = __webpack_public_path__ + "img/offer-detail-logo.2f0e9062.png";